/**
 * タイプセーフに存在チェックを行う
 * @param value 入力値
 */
export const nonNullable = <T>(value: T): value is NonNullable<T> => value != null;
